import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Loader } from '@components';
import { PUBLIC_ROUTE } from '@router/route.constants';

const {
    HOME,
    POPULAR,
    GAMES,
} = PUBLIC_ROUTE;

const routes = [
    {
        path: POPULAR,
        component: lazy(() => import('./Home/Home')),
        exact: true,
    },
    {
        path: GAMES,
        component: lazy(() => import('./Games/Games')),
        exact: true,
    },
];

const HomeRoutes = () => {

    return (
        <Suspense fallback={<Loader />}>
            <Routes>
                {routes.map((route, idx) => (
                    <Route
                        key={idx}
                        exact={route.exact}
                        path={`${route.path}/*`}
                        element={<route.component />}
                    />
                ))}
                <Route
                    exact
                    path="*"
                    element={<Navigate to={`/${HOME}/${POPULAR}`} />}
                />
            </Routes>
        </Suspense>
    );
};

export default HomeRoutes;
